<template>
  <div style="background: #eeeeee;" class="addColaboradores pa-1">
    <v-card>
      <h3 class="white--text text--lighten-4 blue-grey darken-3">
        <v-card-title class="title">
          <v-icon large color="orange lighten-4" class>mdi-account-details</v-icon>R.H > Adicionar Colaboradores
        </v-card-title>
      </h3>
      <v-spacer></v-spacer>
      <v-row>
        <v-col class="pl-5" cols="8">
          <h4 class="orange--text title px-auto">Formulário de Cadastro</h4>

          <!-- Linha do formulario -->
          <v-form class="mt-5" v-model="valid" @submit.prevent>
            <v-text-field outlined label="Nome Completo" hint="Exemplo: Victor Barbieri" prepend-icon="mdi-smart-card"
              required clearable dense :rules="nomeRules" v-model="nome"></v-text-field>
            <h4>Gênero:</h4>
            <v-radio-group row required dense v-model="genero">
              <v-card class="mr-4">
                <v-card-title>
                  <v-icon>mdi-human-male</v-icon>
                  <v-radio label="Masculino" color="orange darken-3" value="Masculino"></v-radio>
                </v-card-title>
              </v-card>
              <v-card>
                <v-card-title>
                  <v-icon>mdi-human-female</v-icon>
                  <v-radio label="Feminino" color="orange darken-3" value="Feminino"></v-radio>
                </v-card-title>
              </v-card>
            </v-radio-group>
            <!--<v-file-input
              accept="image/*"
              small-chips
              outlined
              dense
              v-model="foto"
              label="Foto do Perfil"
              prepend-icon="mdi-camera"
            ></v-file-input> !-->
            <v-text-field outlined label="P.I.S" value prepend-icon="mdi-wallet-plus" dense v-model="pis"
              :rules="pisRules" counter required></v-text-field>
            <v-menu v-model="calendarioEntradaMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field outlined value prepend-icon="mdi-calendar" label="Data de entrada do Colaborador" dense
                  v-model="dataEntrada" required readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="orange darken-3" v-model="date" locale="pt-br"
                @input="calendarioEntradaMenu = false"></v-date-picker>
            </v-menu>

            <h4>Jornada Semanal de Trabalho:</h4>
            <v-radio-group row required dense v-model="jornadaSemanal">
              <v-card class="mr-3">
                <v-card-title>
                  <v-icon>mdi-timer-sand-empty</v-icon>
                  <v-radio label="36 Horas / Semana" color="orange darken-3" value="36:00:00"></v-radio>
                </v-card-title>
              </v-card>
              <v-card>
                <v-card-title>
                  <v-icon>mdi-timer-sand-empty</v-icon>
                  <v-radio label="44 Horas / Semana" color="orange darken-3" value="44:00:00"></v-radio>
                </v-card-title>
              </v-card>
            </v-radio-group>
            <h4>Setores em que trabalha:</h4>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-home-currency-usd</v-icon>
                    <v-switch v-model="setores" dense label="Cobrança" color="orange darken-3"
                      value="Cobrança"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-briefcase-account</v-icon>
                    <v-switch v-model="setores" dense label="Contábil" color="orange darken-3"
                      value="Contábil"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-bank-transfer-in</v-icon>
                    <v-switch dense v-model="setores" label="Escrita Fiscal" color="orange darken-3"
                      value="Escrita Fiscal"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-tie</v-icon>
                    <v-switch v-model="setores" dense label="Imposto de Renda" color="orange darken-3"
                      value="Imposto de Renda"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-tie</v-icon>
                    <v-switch v-model="setores" dense label="Paralegal" color="orange darken-3"
                      value="Paralegal"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-table-account</v-icon>
                    <v-switch v-model="setores" dense label="R.H" color="orange darken-3"
                      value="Recursos Humanos"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-language-javascript</v-icon>
                    <v-switch v-model="setores" dense label="T.I" color="orange darken-3" value="T.I"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-account-tie</v-icon>

                    <v-switch v-model="setores" dense label="Gerência" color="orange darken-3"
                      value="Gerência"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-text-field outlined autocomplete="username" label="E-mail" prepend-icon="mdi-card-account-mail"
              :persistent-hint="true" hint="nome.s" :rules="emailRules" v-model="email" suffix="@contabilidadelider.com"
              dense required></v-text-field>
            <v-text-field outlined autocomplete="current-password" label="Senha" prepend-icon="mdi-lock"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" counter="15" required
              dense :rules="passRules" v-model="senha" @click:append="show1 = !show1"></v-text-field>

            <v-row justify="center">
              <v-col cols="3">
                <v-btn :loading="loading" color="success" :disabled="!valid" x-large
                  @click="(loader = 'loading'), addColaboradores()" type="submit">Adicionar Colaborador</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-divider vertical inset></v-divider>
        <v-col>
          <h4 class="pl-5 orange--text title">Informações</h4>
          <h5 class="subheading">Nome Completo</h5>
          <p class="caption">
            Coloque o nome e o sobrenome do colaborador.
            <br />
            <strong>Exemplo:</strong> Victor Barbieri
          </p>
          <h5 class="subheading">Gênero</h5>
          <p class="caption">Qual é o gênero do Colaborador</p>
          <!-- <h5 class="subheading">Foto do Perfil</h5>
          <p class="caption">
            A foto do perfil não é necessária, porém recomendada.
          </p> !-->
          <h5 class="subheading">P.I.S</h5>
          <p class="caption">
            O P.I.S é
            <strong>necessário</strong> pois é por ele que o controle de ponto
            funcionará.
            <br />
            <strong>
              (Não esquecer de registrar o colaborador TAMBÉM na maquina de
              ponto)
            </strong>
          </p>

          <h5 class="subheading">Data de Entrada</h5>
          <p class="caption">
            O relógio ponto iniciará para este colaborador a partir desta data.
          </p>

          <h5 class="subheading">Jornada Semanal de Trabalho</h5>
          <p class="caption">
            A jornada semanal de trabalho vai definir como o controle ponto se
            comportará de acordo com
            <strong>este</strong> colaborador.
          </p>
          <h5 class="subheading">Setores</h5>
          <p class="caption">
            Os setores em que o colaborador trabalha, é
            <strong>necessário</strong> para liberar permissões especificas no
            sistema.
            <strong>Ao menos um setor deve ser selecionado.</strong>
          </p>
          <h5 class="subheading">E-mail</h5>
          <p class="caption">
            Seguir os mesmo padrões que já usamos. nome.s@contabilidadelider.com
            <br />
            <strong>Exemplo:</strong> victor.b@contabilidadelider.com
          </p>
          <h5 class="subheading">Senha do Painel</h5>
          <p class="caption">
            A senha pode ser definida a gosto do colaborador, no entanto,
            recomendamos usar lider
            <strong>ns</strong>5291
            <br />
            <strong>Exemplo:</strong> lider<strong>vb</strong>5291
          </p>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialogResposta" max-width="320">
      <v-card>
        <v-col v-if="message == 'error'">
          <v-alert type="error" class="text-center" dense>
            Tivemos um problema.
            <strong>Colaborador NÃO</strong> registrado
          </v-alert>
          <p class="caption text-center">
            Por favor contate o setor de T.I.
            <br />
            <strong>E-mail:</strong> ti@contabilidadelider.com
          </p>
          <code v-text="respostaErro"></code>
        </v-col>
        <v-col v-else-if="message == 'success'">
          <v-alert type="success" class="text-center" dense>
            <strong>Colaborador</strong> registrado com sucesso
          </v-alert>
          <p class="caption text-center">
            O Setor de T.I será avisado para criar o e-mail e configurações no
            servidor local
            <br />
          </p>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "addColaboradores",
  data() {
    return {
      show1: false,
      loading: false,
      loader: null,
      valid: true,
      nome: "",
      senha: "",
      foto: null,
      pis: "",
      jornadaSemanal: "44:00:00",
      genero: "Feminino",
      email: "",
      message: "",
      respostaErro: "",
      date: new Date().toISOString().substr(0, 10),
      calendarioEntradaMenu: false,
      dialogResposta: false,
      setores: [],
      nomeRules: [
        (value) => !!value || "Informe o nome Completo",
        (value) =>
          value.length <= 40 || "Seu Nome deve ter no máximo 40 caracteres",
        (value) =>
          /^[a-zA-Z\u00c0-\u024f\u1e00-\u1eff\s]+$/.test(value) ||
          "O nome só pode conter letras",
      ],
      pisRules: [
        (value) => !!value || "Informe o P.I.S do colaborador",
        (value) =>
          value.length <= 11 || "O P.I.S deve conter no máximo 11 numeros",
        (value) => /^\d+$/.test(value) || "O P.I.S deve conter somente numeros",
        (value) =>
          value.length >= 11 || "O P.I.S deve conter no mínimo 11 numeros",
      ],
      emailRules: [
        (value) => !!value || "Informe o e-mail",
        (value) =>
          value.length <= 15 || "Seu usuário deve ter no máximo 15 caracteres",
        (value) =>
          /^[a-z0-9.]+$/.test(value) ||
          "O seu usuário deve conter somente letras, numeros, - (hifem) e . (ponto).",
      ],
      passRules: [
        (value) => !!value || "Informe a senha",
        (value) =>
          value.length <= 15 || "Sua senha deve ter no máximo 15 caracteres",
      ],
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 1000);

      this.loader = null;
    },
    setores(newVal, oldVal) {
      if (newVal.length) {
        this.setores = newVal;
      } else {
        setTimeout(() => (this.setores = oldVal));
      }
    },
  },
  computed: {
    dataEntrada() {
      return this.formatDate(this.date);
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    addColaboradores() {
      this.payload = {
        nome: this.nome,
        genero: this.genero,
        foto: this.foto,
        pis: this.pis,
        dataEntrada: this.dataEntrada,
        jornadaSemanal: this.jornadaSemanal,
        setores: this.setores,
        email: this.email,
        senha: this.senha
      };
      // nao esquecer de colocar o parametro pro dispatch novamente (infos do novo colaborador)
      this.$store.dispatch("registrarUsuario", this.payload).then(
        () => {
          this.dialogResposta = true;
          this.message = "success";
        },
        (error) => {
          this.dialogResposta = true;
          this.loading = false;
          this.respostaErro = error;
          this.message = "error";
        }
      );
    },
  }
};
</script>
